import { Controller } from "@hotwired/stimulus"

// Een filter dat meteen toepast zodra je iets kiest. Een veld mag verderop op de
// pagina staan en met form= bij het formulier horen, dus de controller staat om
// de hele pagina en verstuurt het formulier op id. Zonder JavaScript staat de
// knop "Toon" er en werkt het formulier gewoon.
export default class extends Controller {
  static targets = ["button"]
  static values = { form: String }

  connect() {
    if (this.hasButtonTarget) this.buttonTarget.hidden = true
  }

  submit() {
    document.getElementById(this.formValue)?.requestSubmit()
  }
}
